import { render, staticRenderFns } from "./tcr-status-column.vue?vue&type=template&id=093a4b5e"
import script from "./tcr-status-column.vue?vue&type=script&lang=js"
export * from "./tcr-status-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports